module.exports = __webpack_public_path__ + "media/images/icons/material/login-b048e463c7a8e47ee6d78e4f76e2faea.svg";